export class StoreRelationUpdateRequest {
  storeId?: number;
  relationType?: string;
  all?: number[];
  granted?: number[];
}
